// extracted by mini-css-extract-plugin
module.exports = {"section":"section-header_section__gyh5e","topLine":"section-header_topLine__7IWzZ","title":"section-header_title__Lr4pB","description":"section-header_description___Gglb"};